import React from 'react';
import PropTypes from 'prop-types';

import styles from './info-banner.less';

const InfoBanner = ({
  icon,
  iconAlt,
  containerStyle,
  titleStyle,
  text,
  button,
}) => {
  if (!text.title && !text.body) return null;

  return (
    <div className={styles.container} style={containerStyle}>
      {icon && (
        <img
          data-testid="icon"
          className={styles.image}
          src={icon}
          alt={iconAlt}
        />
      )}
      <div className={styles.content}>
        {text.title && (
          <p data-testid="title" className={styles.title} style={titleStyle}>
            {text.title}
          </p>
        )}
        {text.body && (
          <p data-testid="body" className={styles.body}>
            {text.body}
          </p>
        )}
        {button}
      </div>
    </div>
  );
};

InfoBanner.propTypes = {
  icon: PropTypes.string,
  iconAlt: PropTypes.string,
  containerStyle: PropTypes.shape({
    backgroundColor: PropTypes.string,
    borderTopLeftRadius: PropTypes.string,
    borderTopRightRadius: PropTypes.string,
    borderBottomLeftRadius: PropTypes.string,
    borderBottomRightRadius: PropTypes.string,
  }),
  titleStyle: PropTypes.shape({
    fontWeight: PropTypes.string,
  }),
  text: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string,
  }).isRequired,
  button: PropTypes.element,
};

InfoBanner.defaultProps = {
  icon: '',
  iconAlt: '',
  containerStyle: {
    backgroundColor: '#FFF9C0',
  },
  titleStyle: {
    fontWeight: '',
  },
  text: {
    title: '',
    body: '',
  },
  button: null,
};

export default InfoBanner;
